import ColumnSettingsModal from "./ColumnSettingsModal";

export default ColumnSettingsModal;
